import {
  type OfferCollection,
  offerCollectionSchema,
  type Offer,
  offerSchema, offerFilterSchema, type OfferFilter,
} from '@/types/Wiser/offer.ts'

import { createRestApi, type HttpClient, type ModelApi } from '@jantm/model-core'

export type OfferApi = ModelApi<Offer, OfferCollection, OfferFilter>

/**
 * The HTTP client is injected rather than imported so this package never pins
 * an axios instance, a base URL, or an auth interceptor — the host application
 * owns all three.
 */
export function createOfferApi(
  client: HttpClient,
  endpoint = '/wiser/offerte',
): OfferApi {
  return createRestApi({
    client,
    endpoint,
    schema: offerSchema,
    collectionSchema: offerCollectionSchema,
    filterSchema: offerFilterSchema,
  })
}
